import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"error\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 694.818133L694.818133 768 512 585.1136 329.1136 768 256 694.818133 438.818133 512 256 329.1136 329.1136 256 512 438.852267 694.818133 256 768 329.1136 585.181867 512l182.818133 182.818133zM512 0C229.205333 0 0 229.205333 0 512c0 282.7264 229.205333 512 512 512 282.7264 0 512-229.2736 512-512 0-282.794667-229.2736-512-512-512z\" p-id=\"3783\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id